import { ChairOptimization } from 'pages/ClinicDetailsPage/ClinicDetailsPage';
import { DentistInfo } from 'pages/UpdatedSearchResultPage/utils';
import { FC } from 'react';
import { STEPS } from 'redux/bookingFormSlice';
import Note from './Note/Note';
import Review from './Review/Review';
import HomeAddressNote from './HomeAddressNote/HomeAddressNote';
import PaymentStep from './PaymentStep/PaymentStep';
import { useAppSelector } from 'redux/reduxHooks';

interface Step3Props {
  onClose: () => void;
  clinicId: string;
  practitionerId: string;
  date: string;
  serviceId: string;
  operatoryId?: string;
  timeBlock: number;
  bookingSummaryInfo: {
    avatar: string;
    title: string;
    serviceTitle: string;
    clinicName: string;
    clinicAddress: string;
    clinicEmail: string;
    clinicPhoneNumber: string;
  };
  dentist: DentistInfo;
  chairOptimizations?: ChairOptimization[];
  isPreferredDoctor: boolean;
  page: string;
}

const { REVIEW, FINAL, PAYMENT } = STEPS;

const Step3: FC<Step3Props> = ({ page, bookingSummaryInfo, ...props }) => {
  const {
    bookingFormSlice: {
      step3: { patientInfo },
    },
    clinicDetailsSlice: { clinicData },
  } = useAppSelector((state) => state);

  const isHomeAddressEnabled = clinicData
    ? clinicData.isHomeAddressEnabled
    : // NOTE: Appointment is booked in practitioner page
      false;

  const isHomeAddressNoteDisplayed =
    !patientInfo?.homeAddress && isHomeAddressEnabled;

  return (
    <>
      {page === REVIEW && (
        <Review
          onClose={props.onClose}
          bookingSummaryInfo={bookingSummaryInfo}
          isPreferredDoctor={props.isPreferredDoctor}
          practitionerId={props.practitionerId}
        />
      )}
      {page === FINAL &&
        (isHomeAddressNoteDisplayed ? (
          <HomeAddressNote {...props} />
        ) : (
          <Note {...props} />
        ))}
      {page === PAYMENT && <PaymentStep />}
    </>
  );
};

export default Step3;
